import React, { useEffect, useState } from "react";
import { getContactListApi } from "../../api/contactService";
import { getErrorMessage } from "../../utils/errorHandler";
import Pagination from "../Pagination/Pagination";
import DateFormat from "../../utils/DateFormat";

export default function ContactUsList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const loadData = async () => {
    try {
      setLoading(true);

      const res = await getContactListApi(currentPage, itemsPerPage);

      const data = Array.isArray(res?.data) ? res.data : [];
      const pagination = res?.pagination || {};

      setList(data);

      setTotalItems(
        pagination?.totalItems || pagination?.totalitems || data.length || 0,
      );

      setErrorMessage("");
    } catch (err) {
      console.error(err);
      setErrorMessage(getErrorMessage(err));
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [currentPage]);

  if (loading) {
    return (
      <div className="d-flex vh-100 align-items-center justify-content-center">
        <p className="m-0">Loading Contact List...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Contact Us List</h5>
      </div>

      <div className="card p-3">
        <table className="table table-bordered table-hover">
          <thead className="bg-light">
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Company Name</th>
              <th className="text-dark fw-bold">Subject</th>
              <th className="text-dark fw-bold">Project Type</th>
              <th className="text-dark fw-bold">Email</th>
              <th className="text-dark fw-bold">Phone</th>
              <th className="text-dark fw-bold">Created At</th>
              <th className="text-dark fw-bold">Status</th>
            </tr>
          </thead>

          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No Contacts Found
                </td>
              </tr>
            ) : (
              list.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                  <td>{item.companyName || "-"}</td>
                  <td>{item.subject || "-"}</td>
                  <td>{item.projectType || "-"}</td>
                  <td>{item.email || "-"}</td>
                  <td>{item.phoneNo || "-"}</td>
                  <td>
                    <DateFormat date={item.createdAt} />
                  </td>
                  <td>{item.status || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
}
